import { ServiceFetch } from '../service-fetch'

export default class SaleChangeOutListModel extends ServiceFetch {
    getSaleChangeOutListBy = (data) => this.authFetch({
        url: 'sale-change-out-list/getSaleChangeOutListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}